import * as React from "react";
import { Path } from "./Routes";
import { Route, Redirect, RouteProps } from "react-router";

type RouteComponent =
  | React.ComponentType<any>
  | React.LazyExoticComponent<React.ComponentType<any>>;

interface ProtectedRouteProps extends RouteProps {
  shouldRoute: boolean;
  routeComponent: RouteComponent;
  route: Path;
  redirect: Path;
}

const ProtectedRoute: React.FunctionComponent<ProtectedRouteProps> = ({
  shouldRoute,
  routeComponent,
  route,
  redirect
}) => {
  const ProtectedComponent = routeComponent;
  if (shouldRoute)
    return (
      <Route
        key={route}
        path={route}
        render={routeProps => <ProtectedComponent {...routeProps} />}
      />
    );
  else return <Redirect key={route} path={route} to={redirect} />;
};

export default ProtectedRoute;
